"use client";

import {PropsWithChildren, useContext} from "react";
import {ctx} from "@/components/core/cookies/context";

export function ForCookieState({classification, type = 'consented', children}: PropsWithChildren<{
    classification: 'marketing' | 'statistics' | 'preferences' | 'necessary',
    type?: 'consented' | 'not_consented'
}>) {
    const cookieCtx = useContext(ctx);
    if (cookieCtx[classification] && type === 'consented') {
        return children;
    } else if (!cookieCtx[classification] && type === 'not_consented') {
        return children;
    }
    return null;
}